(function () {
  const FREE_SHIPPING_THRESHOLD_CENTS = 7500;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function ensureBar() {
    let bar = document.getElementById('OnhowFreeShippingBar');
    if (bar) return bar;
    bar = document.createElement('div');
    bar.id = 'OnhowFreeShippingBar';
    bar.className = 'onhow-shipping-bar';
    bar.innerHTML = '<span class="onhow-shipping-bar__text"></span>';
    document.body.appendChild(bar);
    return bar;
  }

  let hideTimeout = null;

  async function showShippingProgress() {
    const cart = await fetch('/cart.js')
      .then((res) => res.json())
      .catch(() => null);
    if (!cart) return;

    const bar = ensureBar();
    const textEl = bar.querySelector('.onhow-shipping-bar__text');
    const remaining = FREE_SHIPPING_THRESHOLD_CENTS - cart.total_price;

    if (remaining > 0) {
      textEl.textContent = `Noch ${formatMoney(remaining)} bis zum kostenlosen Versand!`;
      bar.classList.remove('is-success');
    } else {
      textEl.textContent = 'Gratisversand erreicht!';
      bar.classList.add('is-success');
    }

    clearTimeout(hideTimeout);
    requestAnimationFrame(() => bar.classList.add('is-visible'));
    hideTimeout = setTimeout(() => {
      bar.classList.remove('is-visible');
    }, 4000);
  }

  // Shown as a second message, after the "added to cart" toast (2s visible +
  // 0.3s fade-out) has fully disappeared — never overlapping with it.
  const SHOW_DELAY_MS = 2300;

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        // cartUpdate also fires for removals/quantity changes elsewhere on the
        // site — only the collection-page quick-add flow should trigger this bar.
        if (!event || event.source !== 'collection-quick-add') return;
        setTimeout(() => showShippingProgress(), SHOW_DELAY_MS);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
